import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import apiFetch from "../../../../shared/services/apiClient";
import {
  TableToolbar,
  FilterField,
  FilterInput,
  FilterSelect,
  SortButton,
} from "../../shared/TableToolbar";

export default function TableHeader({
  params = {},
  onParamsChange,
  loading = false,
}) {
  const { t } = useTranslation();

  // Rubros (cuentas de ingreso) para el filtro
  const [rubros, setRubros] = useState([]);
  useEffect(() => {
    apiFetch("/api/finance/catalogo/detalle/?tipo=INGRESO&page_size=500")
      .then((r) => r.json())
      .then((d) => setRubros(Array.isArray(d) ? d : d.results ?? []))
      .catch(() => {});
  }, []);

  function set(field, value) {
    onParamsChange?.({ ...params, [field]: value });
  }

  function clearFilters() {
    onParamsChange?.({
      search: "",
      fecha_desde: "",
      fecha_hasta: "",
      monto_min: "",
      monto_max: "",
      rubro: "",
      ordering: "",
    });
  }

  // Toggle: sin orden → N° ↓ (desc) → N° ↑ (asc) → sin orden
  function toggleOrdering() {
    const current = params.ordering ?? "";
    if (!current) set("ordering", "-numero_factura");
    else if (current === "-numero_factura") set("ordering", "numero_factura");
    else set("ordering", "");
  }

  const orderState =
    params.ordering === "-numero_factura"
      ? "desc"
      : params.ordering === "numero_factura"
        ? "asc"
        : "none";

  const orderLabel =
    orderState === "desc"
      ? t("facturas.nFacturaDesc")
      : orderState === "asc"
        ? t("facturas.nFacturaAsc")
        : t("common.ordenar");

  const activeCount = [
    params.fecha_desde,
    params.fecha_hasta,
    params.monto_min,
    params.monto_max,
    params.rubro,
  ].filter(Boolean).length;

  return (
    <TableToolbar
      search={params.search ?? ""}
      onSearch={(v) => set("search", v)}
      searchPlaceholder={t("facturas.buscarPlaceholder")}
      loading={loading}
      sort={<SortButton state={orderState} label={orderLabel} onToggle={toggleOrdering} />}
      activeFilterCount={activeCount}
      onClearFilters={clearFilters}
      filters={
        <>
          <FilterField label={t("common.fechaEmisionDesde")}>
            <FilterInput
              type="date"
              value={params.fecha_desde ?? ""}
              onChange={(e) => set("fecha_desde", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.fechaEmisionHasta")}>
            <FilterInput
              type="date"
              value={params.fecha_hasta ?? ""}
              onChange={(e) => set("fecha_hasta", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.montoMinimo")}>
            <FilterInput
              type="number"
              min="0"
              step="1000"
              placeholder="0"
              value={params.monto_min ?? ""}
              onChange={(e) => set("monto_min", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.montoMaximo")}>
            <FilterInput
              type="number"
              min="0"
              step="1000"
              placeholder={t("common.sinLimite")}
              value={params.monto_max ?? ""}
              onChange={(e) => set("monto_max", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.rubroFiltro")}>
            <FilterSelect
              value={params.rubro ?? ""}
              onChange={(e) => set("rubro", e.target.value)}
            >
              <option value="">{t("common.todosLosRubros")}</option>
              {rubros.map((r) => (
                <option key={r.id} value={String(r.id)}>
                  {r.nombre}
                </option>
              ))}
            </FilterSelect>
          </FilterField>
        </>
      }
    />
  );
}
